import React, { useEffect, useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';

const KycLinearProgress = ({ isDeterminate, determinateTime }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval;

    if (isDeterminate) {
      // Reset progress to 0 when switching to determinate
      setProgress(0);

      const totalDuration = determinateTime; // Time in milliseconds
      const intervalTime = 100; // Update every 100ms
      const speedMultiplier = 1.2; // Speed multiplier for 1.5x faster progress
      const increment = (100 / totalDuration) * intervalTime * speedMultiplier;

      interval = setInterval(() => {
        setProgress((prevProgress) => {
          const newProgress = prevProgress + increment;
          if (newProgress >= 100) {
            clearInterval(interval);
            return 100;
          }
          return newProgress;
        });
      }, intervalTime);
    }

    return () => {
      if (interval) clearInterval(interval); // Cleanup on unmount or when isDeterminate changes
    };
  }, [isDeterminate, determinateTime]);

  return (
    <div>
      <LinearProgress 
        variant={isDeterminate ? 'determinate' : 'indeterminate'} 
        value={isDeterminate ? progress : undefined} 
      />
    </div>
  );
}

export default KycLinearProgress;